/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  CreateProductionSiteMutationRequest,
  CreateProductionSiteMutationResponse,
} from "../types/CreateProductionSite.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const createProductionSiteMutationKey = () =>
  [{ url: "/v1/production-site" }] as const

export type CreateProductionSiteMutationKey = ReturnType<
  typeof createProductionSiteMutationKey
>

/**
 * @summary Create a production site
 * {@link /v1/production-site}
 */
export async function createProductionSite(
  data: CreateProductionSiteMutationRequest,
  config: Partial<RequestConfig<CreateProductionSiteMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateProductionSiteMutationResponse,
    ResponseErrorConfig<Error>,
    CreateProductionSiteMutationRequest
  >({
    method: "POST",
    url: `/v1/production-site`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createProductionSiteMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<CreateProductionSiteMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = createProductionSiteMutationKey()
  return mutationOptions<
    ResponseConfig<CreateProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateProductionSiteMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createProductionSite(data, config)
    },
  })
}

/**
 * @summary Create a production site
 * {@link /v1/production-site}
 */
export function useCreateProductionSite<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateProductionSiteMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateProductionSiteMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<CreateProductionSiteMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? createProductionSiteMutationKey()

  const baseOptions = createProductionSiteMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<CreateProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateProductionSiteMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateProductionSiteMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateProductionSiteMutationRequest },
    TContext
  >
}
